function setBlockAnchorNavPos(){
	var scrollTop = $(this).scrollTop();	
	var stickyEl = $('.blockAnchorNav .inner');
	var stickyElUl = $('.blockAnchorNav .inner ul');
	var mainTop = $('main').offset().top;
	var mainHeight = $('main').outerHeight();
	var mainBottom = mainTop + mainHeight;
	var mainLimitBottom = mainBottom - stickyElUl.outerHeight();
	
	if (scrollTop < mainTop) {
		// console.log('fixed at top');
		stickyEl.removeClass('sticky').css({
			'top': 0
		});
	} else if (scrollTop > mainLimitBottom) {
		// console.log('fixed at bottom');
		stickyEl.removeClass('sticky').css({
			'top': mainHeight - stickyElUl.outerHeight()
		});
	} else {
		// console.log('fixed scroll');
		stickyEl.css({
			'top': 0
		}).addClass('sticky');
	}

}


$(document).ready(function(){

	if ($('.blockAnchorNav').length) {

		// -- sticky position --
		setBlockAnchorNavPos();

		// -- menu anchor active section --
		$(document).on('scroll resize orientationchange', function(){
			var scrollTop = $(this).scrollTop();
			$('.blockAnchorNav li a').each(function() {
				var el = $(this).attr('href');
				var elTop = $(el).offset().top;
				if (scrollTop >= (elTop - 85)) {
					$('.blockAnchorNav li a').removeClass('active');
					$(this).addClass('active');
				}
			});
		});

	}
});


$(document).on('scroll resize orientationchange', function(){
	if ($('.blockAnchorNav').length) {
		setBlockAnchorNavPos();
	}
});


$(document).on('lazybeforeunveil', function(){
	if ($('.blockAnchorNav').length) {
		setBlockAnchorNavPos();
	}
});
